import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const ListClassName = `${CLASS_NAME_PREFIX}-list`;
export const ListItemClassName = `${CLASS_NAME_PREFIX}-listitem`;
export const ListItemTitleClassName = `${ListItemClassName}__title`;
export const ListItemWrapperClassName = `${ListItemClassName}__wrapper`;
export const ListItemIDescClassName = `${ListItemClassName}__idesc`;
export const ListItemBDescClassName = `${ListItemClassName}__bdesc`;
export const ListItemTextOverflowClassName = `${ListItemClassName}_text-overflow`;
